/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/* eslint-disable no-console */
// sweetalert2 components
import Swal from "sweetalert2";

import PropTypes from "prop-types";

// Sweet Alerts page components
import Template from "layouts/pages/sweet-alerts/components/Template";
import SoftButton from "components/SoftButton";

function showAlert(title, desc, duration) {
    let timerInterval;
    
    Swal.fire({
        title: title,
        html: desc,
        timer: duration,
        timerProgressBar: true,
        didOpen: () => {
            Swal.showLoading();
            timerInterval = setInterval(() => {
                const content = Swal.getHtmlContainer();
                if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                        b.textContent = Swal.getTimerLeft();
                    }
                }
            }, 100);
        },
        willClose: () => {
            clearInterval(timerInterval);
        },
    }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
            console.log("I was closed by the timer");
        }
    });
}

function SaveButton({ title, desc, duration }) {

    return <SoftButton variant="gradient" color="dark" onClick={() => { showAlert(title, desc, duration); }}>
        {"Save"}
    </SoftButton>

    // return <Template title="A message with auto close" action={showAlert} />;
}

SaveButton.propTypes = {
    title: PropTypes.string,
    desc: PropTypes.string,
    duration: PropTypes.number,
}

export default SaveButton;
